(function ($) {
	'use strict';

	var notification_banner =
		'<div class="cc--component-container cc--emergency-alert"><div class="c--component c--emergency-alert">';
	notification_banner += '<div class="inner-wrapper emergency-alert">';
	notification_banner +=
		'<button class="close-btn" aria-label="Close Notification">';
	notification_banner +=
		'<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" class="icon-close" viewBox="0 0 35 35"><path fill="#FFF" fill-rule="evenodd" d="M26 10.4 24.6 9l-7.1 7.1L10.4 9 9 10.4l7.1 7.1L9 24.6l1.4 1.4 7.1-7.1 7.1 7.1 1.4-1.4-7.1-7.1z" clip-rule="evenodd"/></svg>';
	notification_banner +=
		'</button><div class="title-container"><div class="f--field f--section-title"><h2></h2></div><span class="date"></span></div><div class="content-container"><div class="f--field f--wysiwyg"></div><div class="f--field f--link"><a class="link" href="" aria-label=""></a></div></div></div></div></div>';

	var takeover_banner =
		'<button class="toggle-btn" aria-label="Toggle Notification"><span>Emergency Alert</span><svg version="1.1" id="icon-arrow-up" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 35 35" enable-background="new 0 0 35 35" xml:space="preserve">';
	takeover_banner +=
		'<polygon id="icon-arrow-up-path" fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" points="17.5,15.7 23.7,21.9 25,20.6 17.5,13.1 10,20.6 11.3,21.9"/></svg></button>';

	var storageName = 'alert-banner-closed';
	var minimizedStorageName = 'alert-banner-minimized';
	var fetchAlert = function () {

		return $.ajax('/wp-json/wp/v2/alert?per_page=1', {
			dataType: 'json',
		});
	};

  var readStorage = function (name) {
    var result = false;
    var stored = localStorage.getItem(name);
    if (stored) {
      result = JSON.parse(stored);
    }
    return result;
  };

  var writeStorage = function (name, data) {
    localStorage.setItem(name, JSON.stringify(data));
  };

  Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + h * 60 * 60 * 1000);
    return this;
  };

  $(document).ready(function () {
    var container = $('.alert-banner-block-container');
    container.once('alert-banner-init').each(function () {
      var $wrapper = $(this);
      var closeState = readStorage(storageName);
      fetchAlert()
		  .done(function (data, textStatus, jqXHR) {

          if (data.length) {
			  var lastChange = new Date(data[0].modified);

            if (
              data[0].guid.rendered !== closeState.guid ||
              lastChange > new Date(closeState.lastChange) ||
              new Date() > new Date(closeState.expires)
            ) {
              $wrapper.html(notification_banner);
              if (data[0].hasOwnProperty('title')) {
                $('.cc--emergency-alert .f--section-title h2').text(
                  data[0].title.rendered
                );
              }

              if (data[0].hasOwnProperty('acf')) {
                if (
                  data[0].acf.hasOwnProperty('alert_type') &&
                  data[0].acf.alert_type == 'takeover'
                ) {
                  var is_open = 'is-open';
                  if (readStorage(minimizedStorageName)) {
                    is_open = '';
                  }
                  $('.cc--component-container .cc--emergency-alert').addClass(
                    'takeover ' + is_open
                  );
                  $(takeover_banner).insertBefore('.emergency-alert');
                }
                else {
                  if (data[0].acf.hasOwnProperty('color')) {
                    $('.cc--component-container .cc--emergency-alert').addClass(
                      data[0].acf.color
                    );
                  }
                }

                if (data[0].acf.hasOwnProperty('date_time')) {
                  $('.cc--emergency-alert .date').text(data[0].acf.date_time);
                }

                if (data[0].acf.hasOwnProperty('description')) {
                  $('.cc--emergency-alert .f--wysiwyg').html(
                    '<p>' + data[0].acf.description + '</p>'
                  );
                }

                if (
                  data[0].acf.hasOwnProperty('link') &&
                  data[0].acf.link.hasOwnProperty('url')
                ) {
                  $('.cc--emergency-alert .link').attr(
                    'href',
                    data[0].acf.link.url
                  );
                  $('.cc--emergency-alert .link').html(
                    data[0].acf.link.title + $('.link').html()
                  );
                  $('.cc--emergency-alert .link').attr(
                    'aria-label',
                    'Link to ' + data[0].acf.link.title
                  );
                } else {
                  $('.cc--emergency-alert .f--link').hide();
                }
              }

              var alert_container = $(
                '.cc--component-container .cc--emergency-alert'
              );
              var $btnClose = $('.close-btn', alert_container);
              var $body = $('body');
              var toggle = $('.cc--emergency-alert .toggle-btn');

              $btnClose.click(function () {
                var $emergencyAlert = $('.cc--emergency-alert:not(.takeover)').height();
                var $alertsWrapper = $('.alerts-wrapper').height();
                var alretHeight = $alertsWrapper - $emergencyAlert;
                $body.addClass('hide-emergency-banner');
                content.css('margin-top', alretHeight);
              });

              toggle.click(() => {
                if (alert_container.hasClass('is-open')) {
                  writeStorage(minimizedStorageName, {
                    guid: data[0].guid.rendered,
                    lastChange: lastChange.toISOString(),
                    expires: new Date().addHours(24).toISOString(),
                  });
                } else {
                  localStorage.removeItem(minimizedStorageName);
                }
                alert_container.toggleClass('is-open');
                alertOpen();
              });

              let alertOpen = () => {
                if (alert_container.hasClass('is-open')) {
                  $body.addClass('emergency-alert-open');
                } else {
                  $body.removeClass('emergency-alert-open');
                }
              };

              alertOpen();

              var closeButton = $('.close-btn', alert_container);
              closeButton.on('click', function (e) {
                e.preventDefault();
                $body.addClass('hide-banner');
                writeStorage(storageName, {
                  guid: data[0].guid.rendered,
                  lastChange: lastChange.toISOString(),
                  expires: new Date().addHours(24).toISOString(),
                });
              });
            }

            var content = $('#main-content');

          }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.error(errorThrown);
        });
    });
  });
})(jQuery);
